import { useState } from "react";
import Header from './Header';
import SubHeader from './SubHeader';
import SideBar from "./../sidebar/Sidebar.js";
import './main-container.scss';
const MainContainer = ({ children, breadcrums }) => {
  const [sidebarIsOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => setSidebarOpen(!sidebarIsOpen);

  return (
    <>
      <Header />
      <SubHeader toggleSidebar={toggleSidebar} breadcrums={breadcrums} />
      <SideBar isOpen={sidebarIsOpen} />
      <div className="content">{children}</div>
    </>
  );
};

export default MainContainer;
